import { h, JSX } from 'preact'

export interface ProductsSidebarProps {
    title: string
    firstParagraph: string
    textBeforeLink: string
    link: {
        text: string
        url: string
    }
    textAfterLink: string
}

export const ProductsSidebar = (props: ProductsSidebarProps): JSX.Element => {
    return (
        <div class="products-sidebar">
            <h1 class="products-sidebar__title">{props.title}</h1>
            <div class="products-sidebar__text">{props.firstParagraph}</div>
            <div class="products-sidebar__text">
                {props.textBeforeLink}
                <a href={props.link.url}>{props.link.text}</a>
                {props.textAfterLink}
            </div>
        </div>
    )
}
